import { useState } from 'react';
import type { FormEvent } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { api, ApiError } from '../lib/api';
import { useAuthStore } from '../stores/authStore';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';

export function LoginPage(): JSX.Element {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const setUser = useAuthStore((s) => s.setUser);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (isAuthenticated) return <Navigate to="/" replace />;

  const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    api.auth
      .login({ username, password })
      .then(({ user }) => {
        setUser(user);
        navigate('/');
      })
      .catch((err: unknown) => {
        if (err instanceof ApiError && err.status === 401) {
          setError('Identifiants incorrects.');
        } else {
          setError('Une erreur est survenue. Réessaie plus tard.');
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-6">
      <section className="w-full max-w-sm bg-slate-900/60 border border-slate-800 rounded-2xl p-8 shadow-xl">
        <h1 className="text-3xl font-bold text-floryon-green tracking-tight">Cockpit Floryon</h1>
        <p className="mt-1 text-xs text-slate-500">Connexion à votre espace de travail.</p>

        <form className="mt-6 flex flex-col gap-4" onSubmit={handleSubmit}>
          <Input
            label="Identifiant"
            value={username}
            onChange={(e): void => setUsername(e.target.value)}
            autoComplete="username"
            autoFocus
            required
          />
          <Input
            label="Mot de passe"
            type="password"
            value={password}
            onChange={(e): void => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
          {error !== null && <p className="text-xs text-red-400">{error}</p>}
          <Button type="submit" disabled={submitting}>
            {submitting ? 'Connexion…' : 'Se connecter'}
          </Button>
        </form>
      </section>
    </main>
  );
}
